import "./resources_request_report.scss";

document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("report-request-form") as HTMLFormElement;
  const submitButton = document.getElementById("id_submit") as HTMLInputElement;
  if (!form || !submitButton) {
    return;
  }

  form.addEventListener("submit", function(ev) {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.value = "Please wait...";
  });
});
